var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.loaded)?_c('div',{staticClass:"chart",style:(`height: ${_vm.outerHeight}`)},[_c('apexchart',{attrs:{"type":"bar","height":_vm.innerHeight,"options":_vm.options,"series":_vm.series}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }